import * as React from "react";
const label = (
  <>
    <h3>Ayush Jaiswal</h3>
    <p>1418 Riverwood Drive, Suite 3245 Cottonwood, DL 110092, India</p>
    <p>(+91) 9876 543 210</p>
  </>
);
const fixture = {
  label,
  checked: true,
  value: "test",
  onClick: null,
};

export default fixture;
